import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, AuthService, GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { ConfirmationMessage, Dealer } from 'app/core/model/entity-model';

@Component({
    selector: 'app-confirmation-email-dialog',
    templateUrl: './confirmation-email-dialog.component.html',
    styleUrls: ['./confirmation-email-dialog.component.scss'],
    standalone: false
})
export class ConfirmationEmailDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    types: any;
    messages: ConfirmationMessage[];
    dealers: Dealer[];
    selectedMessage: any;


    proposal: any;
    processing = false;
    committees: any;
    selectedCommitteeId: number;
    members: any[];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, public auth: AuthService) {}

    async ngOnInit() {
        this.messages = await this.uow.getConfirmationMessages() as ConfirmationMessage[];
        this.types = this.uow.lookups.confirmationTypes;
        this.members = [];
        this.committees = this.uow.lookups.committees;
        this.selectedCommitteeId = 4;
        await this.getCommitteeMembers();
    }

    selectionChanged(e) {
        console.log(e)
        this.getCommitteeMembers();

    }

    async getCommitteeMembers(){
        let members = [];
        // if (this.selectedCommitteeId === 1) members = _.uniqBy((await this.uow.getMembersByCommitteeIds([2, 3, 4])) as CommitteeMember[], 'personId');
        // else members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
        this.members = _.sortBy(members, 'person.lastName');
    }

    remove() {}


    async save() {
        this.processing = true;
        this.result.next({ success: true, value: this.members });
    }

    close() {
        this.processing = true;
        this.result.next(false);
    }
}
